import axios from "axios";
import { useState, useEffect } from "react";
import { Box, IconButton, useToast, useDisclosure, Image, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverCloseButton, PopoverHeader, PopoverBody, Button, SimpleGrid, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter } from "@chakra-ui/react";
import { BiTrash, BiShow } from "react-icons/bi";
import { createColumnHelper } from "@tanstack/react-table";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { Table } from "../../features/admin/components";
import usePagination from "../../features/admin/usePagination";
import { Header } from "../../shared/components";

const deleteTip = async (id: string) => {
  let baseUrl = 'https://f8jcwt5745.execute-api.us-east-1.amazonaws.com/dev';
  if (localStorage.getItem("backend_env") === "prod") {
    baseUrl = 'https://vwt190bfa2.execute-api.us-east-1.amazonaws.com/prod';
  } else if (localStorage.getItem("backend_env") === "stag") {
    baseUrl = 'https://hp9zzz7tf8.execute-api.us-east-1.amazonaws.com/stag';
  }

  const accessToken = JSON.parse(localStorage.getItem("user")!).access_token;

  return axios.delete(
    `${baseUrl}/tips/${id}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};

function ViewTipsPage() {
  const [pagination, setPagination] = usePagination();
  const columnHelper = createColumnHelper<any>();
  const queryClient = useQueryClient();
  const toast = useToast();
  const { onOpen, isOpen, onClose } = useDisclosure();
  const [confirm, setConfirm] = useState<boolean>(false);
  const [id, setId] = useState<string | null>(null);
  const [selectedImages, setSelectedImages] = useState<string[]>([]);

  
  const { isLoading, data } = useQuery({
    queryKey: ["tips-list", pagination],
    queryFn: async () => {
      let baseUrl = 'https://f8jcwt5745.execute-api.us-east-1.amazonaws.com/dev';
      if (localStorage.getItem("backend_env") === "prod") {
        baseUrl = 'https://vwt190bfa2.execute-api.us-east-1.amazonaws.com/prod';
      } else if (localStorage.getItem("backend_env") === "stag") {
        baseUrl = 'https://hp9zzz7tf8.execute-api.us-east-1.amazonaws.com/stag';
      }

      const access_token = JSON.parse(localStorage.getItem("user")!).access_token;

      const response = await axios.get(`${baseUrl}/tips`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });

      if (!response?.status) {
        throw new Error(response?.data?.message);
      }

      return {
        data: response?.data,
      };
    },
    keepPreviousData: true,
  });

  const handleDelete = async () => {
    if (id) {
      try {
        await deleteTip(id);
        toast({
          title: "Success",
          description: "Tip Deleted Successfully",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
        queryClient.invalidateQueries(["tips-list", pagination]);
      } catch (error) {
        toast({
          title: "Error",
          description: "Failed to delete tip",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      } finally {
        setConfirm(false);
        setId(null);
        onClose();
      }
    }
  };

  useEffect(() => {
    if (confirm) {
      handleDelete();
    }
  }, [confirm]);

  const columns = [
    columnHelper.accessor("title", {
      header: () => <span>Title</span>,
      cell: (info) => <span>{info.getValue()}</span>,
    }),
    columnHelper.accessor("cover_image", {
      header: () => <span>Cover Image URL</span>,
      cell: (info) => <span>{info.getValue()}</span>,
    }),
    columnHelper.accessor("user_id", {
      header: () => <span>User ID</span>,
      cell: (info) => <span>{info.getValue()}</span>,
    }),
    columnHelper.accessor("created_at", {
      header: () => <span>Created At</span>,
      cell: (info) => <span>{new Date(info.getValue()).toLocaleDateString()}</span>,
    }),
    columnHelper.accessor("updated_at", {
      header: () => <span>Updated At</span>,
      cell: (info) => <span>{new Date(info.getValue()).toLocaleDateString()}</span>,
    }),
    columnHelper.accessor("action", {
      header: () => <span>Action</span>,
      cell: (info) => (
        <span>
          <Popover>
            <PopoverTrigger>
              <IconButton
                aria-label="Show Images"
                icon={<BiShow size={"24px"} />}
                onClick={() => {
                  setSelectedImages(info.row.original.imageUrls);
                }}
                mr={2}
              />
            </PopoverTrigger>
            <PopoverContent>
              <PopoverArrow />
              <PopoverCloseButton />
              <PopoverHeader>Additional Images</PopoverHeader>
              <PopoverBody>
                <SimpleGrid columns={3} spacing={4}>
                  {selectedImages.map((url, index) => (
                    <Image key={index} src={url} alt={`Image ${index + 1}`} boxSize="100px" />
                  ))}
                </SimpleGrid>
              </PopoverBody>
            </PopoverContent>
          </Popover>
          <IconButton
            aria-label="Delete"
            icon={<BiTrash size={"24px"} color="red" />}
            onClick={() => {
              setId(info.row.original.id);
              onOpen();
            }}
          />
        </span>
      ),
    }),
  ];

  const rowData = data?.data?.data?.rows || [];
console.log(rowData);
  return (
    <Box>
      <Header
        buttonIcon={null}
        header={"Tips-list"}
        buttonText={undefined}
        handleOpen={() => {}}
      />
      <Table
        title="Tips List"
        columns={columns}
        rowData={rowData}
        pagination={pagination}
        setPagination={setPagination}
        loading={isLoading}
      />
      <Modal
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Tip</ModalHeader>
          {/* <ModalCloseButton /> */}
          <ModalBody>
            Are you sure you want to delete this tip?
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={onClose}>Cancel</Button>
            <Button colorScheme="red" onClick={() => setConfirm(true)} ml={3}>Delete</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}

export default ViewTipsPage;
